import { useMutation } from 'react-query';

import { getAiResourcesMitigation as mutationFn } from 'api/endPoints/getAiResourcesMitigation';

export const useMutationGenerateResourcesMitigation = () => {
    return useMutation<
        {
            mitigation: string;
            taskId: number;
        },
        QueryError,
        {
            taskId: number;
            laneId: string | number;
            isVirtual: boolean;
            cardId: number | null;
            versionId: number;
        }
    >((params) => mutationFn(params));
};
